// extracted by mini-css-extract-plugin
module.exports = {"block":"block-a8d358","title":"title-a8d358","content":"content-a8d358","more":"more-a8d358","block_adapt_default":"block_adapt_default-a8d358"};